import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { InfinitySpin } from 'react-loader-spinner';
import { UserLoginUser } from '../../redux/user/user_auth/user_authServiceSync';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { values } from 'lodash';

const baseSchema = Yup.object({
  email: Yup.string().email().required(),
  password: Yup.string().min(6).required(),
});

const Signin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const { loading } = useSelector((state) => state.user_auth);

  const handleSubmited = async (value, { resetForm }) => {
    const payload = {
      ...value,
      navigate,
    };

    await dispatch(UserLoginUser({ ...payload }));

    resetForm();
  };

  const { handleChange, handleSubmit, errors, values } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="d-flex flex-column h-100 p-3">
      <div className="d-flex flex-column flex-grow-1">
        <div className="row h-100">
          <div className="col-xxl-7">
            <div className="row justify-content-center h-100">
              <div className="col-lg-6 py-lg-5">
                <div className="d-flex flex-column h-100 justify-content-center">
                  <div className="auth-logo mb-4">
                    <a href="/">
                      <img
                        src="/assets/img/logo/glorious_logo.webp"
                        height="24"
                        alt="logo"
                        className="h-[3.875rem]"
                      />
                    </a>
                  </div>
                  <h2 className="fw-bold fs-24">Sign In</h2>
                  <p className="text-muted mt-1 mb-4">
                    Enter your email address and password to access your
                    Dashboard.
                  </p>
                  <div className="mb-5">
                    <form className="authentication-form">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="email">
                          Email
                        </label>
                        <input
                          value={values.email || ''}
                          type="email"
                          id="email"
                          name="email"
                          className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                          placeholder="Enter your email"
                          onChange={handleChange}
                          required
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                      </div>

                      <div className="mb-3 relative">
                        <NavLink
                          to="/auth/reset_password"
                          className="float-end text-muted text-unline-dashed ms-1"
                        >
                          Reset password
                        </NavLink>
                        <label className="form-label text-lg" htmlFor="password">
                          Password
                        </label>
                        <div className="relative">
                          <input
                            value={values.password || ''}
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                            placeholder="Enter your password"
                            required
                            onChange={handleChange}
                          />
                          <span
                            onClick={togglePasswordVisibility}
                            className="absolute top-50 end-0 translate-middle-y pe-3"
                            style={{ cursor: 'pointer' }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                        {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                      </div>


                      <div className="mb-1 text-center d-grid">
                        <button
                          className="btn btn-soft-primary"
                          type="button"
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div className="w-full flex items-center justify-center">
                              <InfinitySpin width="80" color="#F61B1C" />
                            </div>
                          ) : (
                            <>Sign In</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                  <p className="text-danger text-center">
                    Don't have an account?{' '}
                    <NavLink
                      to="/auth/signup"
                      className="text-dark fw-bold ms-1"
                    >
                      Sign Up
                    </NavLink>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xxl-5 d-none d-xxl-flex">
            <div className="card h-100 mb-0 overflow-hidden">
              <div className="d-flex flex-column h-100">
                <img
                  src="/assets/images/small/img-10.jpg"
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signin;
